export class AccountFeesModel {
  accountNumber: string = '';
  fundCode: string = '';
  product: string = '';
  adminAssetFee: number = 0;
  memberFee: number = 0;
}
